export function darkenHexColor(hexColor, darknessPercentage) {
  // Remove the '#' symbol if present
  hexColor = hexColor.replace("#", "");

  // Convert the hex color code to RGB
  const red = parseInt(hexColor.substr(0, 2), 16);
  const green = parseInt(hexColor.substr(2, 2), 16);
  const blue = parseInt(hexColor.substr(4, 2), 16);

  // Calculate the darkness value
  const darkness = darknessPercentage / 100;

  // Calculate the darkened RGB values
  const darkenedRed = Math.max(0, Math.round(red - red * darkness));
  const darkenedGreen = Math.max(0, Math.round(green - green * darkness));
  const darkenedBlue = Math.max(0, Math.round(blue - blue * darkness));

  // Convert the darkened RGB values back to hex
  const darkenedHex = `#${darkenedRed
    .toString(16)
    .padStart(2, "0")}${darkenedGreen
    .toString(16)
    .padStart(2, "0")}${darkenedBlue.toString(16).padStart(2, "0")}`;

  return darkenedHex;
}
